import React from 'react';
import RangeContext from 'components/triggers/rule-context/RangeContext';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import FlatButton from 'components/pure/utils/FlatButton';
import rulePopout from '../RulePopout';

class ScoresContextSelectContainer extends React.Component {
  render() {
    const canSave = true;
    return (
      <div className="rule-select-popup">
        <RangeContext {...this.props} />
        <div className="selection-buttons">
          <button
            className={canSave ? 'save' : 'save disabled'}
            disabled={!canSave}
            onClick={this.props.saveSelection}>
            <CheckIcon color={canSave ? 'white' : 'gray'} />
          </button>
          <FlatButton onClick={this.props.cancelSelection}>Cancel</FlatButton>
        </div>
      </div>
    );
  }
}

export default rulePopout(ScoresContextSelectContainer);
